import {useEffect} from 'react';
import {useShallow} from 'zustand/react/shallow';

import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

/**
 * Runs an effect any time a resource becomes outdated compared to the student stored in the store.
 * Will only run if student is non-null.
 * @param {number} resourceLastFetchedAt - the timestamp the resource was last fetched at
 * @param {function} effect - the effect to run when the resource becomes outdated
 */
export default function useOnResourceStale(resourceLastFetchedAt: number, effect: () => void) {
  const {student, studentLastFetchedAt} = useStudentDashboard(
    useShallow((state) => ({
      student: state.student,
      studentLastFetchedAt: state.studentLastFetchedAt
    }))
  );

  useEffect(() => {
    if (student !== null && resourceLastFetchedAt < studentLastFetchedAt) {
      effect();
    }
  }, [effect, resourceLastFetchedAt, student, studentLastFetchedAt]);
}
